import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { AppShell } from "../components/layout/AppShell";
import { ScopeBar } from "../components/data/ScopeBar";
import { WhTabs } from "../features/warehouse/WhTabs";
import { WhStats } from "../features/warehouse/WhStats";
import { WhActions } from "../features/warehouse/WhActions";
import { WhWarehousesTab } from "../features/warehouse/WhWarehousesTab";
import { WhBalancesTab } from "../features/warehouse/WhBalancesTab";
import { WhMovementsTab } from "../features/warehouse/WhMovementsTab";
import { WhDocsTab } from "../features/warehouse/WhDocsTab";
import { WhIncomingTab } from "../features/warehouse/WhIncomingTab";
import { WhCountsTab } from "../features/warehouse/WhCountsTab";
import client from "../api/client";

// إدارة المخازن الشاملة: KPIs + إجراءات ملوّنة + 8 تبويبات ثابتة — لا نوافذ منبثقة (كل عملية صفحة).
export default function WarehousePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const [branchId, setBranchId] = useState(() => localStorage.getItem("wh.branchId") || "");
  const [tab, setTab] = useState(params.get("tab") || "balances");
  const onBranch = (v) => { setBranchId(v); localStorage.setItem("wh.branchId", v || ""); };
  const changeTab = (v) => { setTab(v); setParams({ tab: v }); };
  useEffect(() => { const q = params.get("tab"); if (q && q !== tab) setTab(q); /* eslint-disable-next-line */ }, [params]);

  const download = async () => {
    try {
      const r = await client.get(`/warehouse/export/balances.xlsx${branchId ? `?branch_id=${branchId}` : ""}`,
                                  { responseType: "blob" });
      const url = URL.createObjectURL(new Blob([r.data]));
      const a = document.createElement("a"); a.href = url; a.download = "warehouse_balances.xlsx";
      a.click(); URL.revokeObjectURL(url);
    } catch { toast.error(t("errors.generic")); }
  };

  const dispatch = (action) => {
    if (!branchId) { toast.error(t("warehouse.wh.pickBranch")); return; }
    if (action === "add_warehouse") changeTab("warehouses");
    else if (action === "export") download();
    else if (action === "import") toast.info(t("warehouse.actions.importSoon"));
    else if (action === "receive") changeTab("incoming");
    else if (action === "issue") navigate("/warehouse/issues/new");
    else if (action === "transfer") navigate("/warehouse/transfers/new");
    else if (action === "count") navigate("/warehouse/counts/new");
    else if (action === "transfers_log") changeTab("transfers");
  };

  return (
    <AppShell title={t("warehouse.title")} subtitle={t("warehouse.subtitle")}>
      <div className="grid gap-4">
        <ScopeBar value={branchId} onChange={onBranch} testid="wh-scope" />
        <WhStats branchId={branchId} />
        <WhActions onAction={dispatch} disabled={!branchId} />
        <WhTabs value={tab} onChange={changeTab} />
        {tab === "warehouses" && <WhWarehousesTab branchId={branchId} />}
        {tab === "balances" && <WhBalancesTab branchId={branchId} />}
        {tab === "movements" && <WhMovementsTab branchId={branchId} />}
        {tab === "receipts" && <WhDocsTab branchId={branchId} kind="receipts" />}
        {tab === "incoming" && <WhIncomingTab branchId={branchId} />}
        {tab === "issues" && <WhDocsTab branchId={branchId} kind="issues" />}
        {tab === "transfers" && <WhDocsTab branchId={branchId} kind="transfers" />}
        {tab === "counts" && <WhCountsTab branchId={branchId} />}
      </div>
    </AppShell>
  );
}
